export default "__VITE_ASSET__D43_fNWu__"